@if (compatibility.recoveryVisible()) {
  <sm-backend-recovery-banner
    [title]="'apiCompatibility.unavailable.title' | translate"
    [description]="'shell.recovery.description' | translate"
    [countdownText]="compatibility.state() === 'checking'
      ? ('apiCompatibility.checking.message' | translate)
      : ('shell.recovery.countdown' | translate: {seconds: compatibility.retryCountdownSeconds()})"
    [countdownSeconds]="compatibility.retryCountdownSeconds()"
    [retryDelaySeconds]="compatibility.retryDelaySeconds()"
    [progressAriaLabel]="'shell.recovery.progressAriaLabel' | translate"
    [retryLabel]="'prices.retry' | translate"
    [checking]="compatibility.state() === 'checking'"
    (retryRequested)="compatibility.recheck()">
  </sm-backend-recovery-banner>
} @else if (isOpen$ | async) {
  <sm-confirmation-dialog
    class="server-error-dialog"
    [class.server-error-dialog--web-fallback]="canOpenWebVersion"
    [isOpen]="true"
    panelVariant="form"
    [title]="serverErrorDialogService.titleKey | translate"
    [description]="canOpenWebVersion ? '' : (serverErrorDialogService.messageKey | translate)"
    [confirmationText]="''"
    [cancelLabel]="'auth.common.closeButton' | translate"
    [confirmLabel]="(serverErrorDialogService.canRetry ? 'prices.retry' : 'auth.common.closeButton') | translate"
    [closeLabel]="'auth.common.closeButton' | translate"
    [confirmTone]="'danger'"
    [contentAlign]="'center'"
    [showCloseButton]="true"
    [showCancelButton]="serverErrorDialogService.canRetry"
    [showConfirmButton]="true"
    [heroIconName]="'warning-outline'"
    (cancelRequest)="handleClose()"
    (confirmRequest)="handleConfirm()">
    @if (canOpenWebVersion) {
      <p class="web-fallback-message">
        {{ 'apiCompatibility.incompatible.androidMessage' | translate }}
        <a href="https://invemory.com" (click)="handleOpenWebVersion($event)">{{ 'apiCompatibility.incompatible.openWebVersion' | translate }}</a>.
        {{ 'apiCompatibility.incompatible.webVersionDetails' | translate }}
      </p>
    }
    @if ((canSeeDetails$ | async) && serverErrorDialogService.details) {
      <details #errorDetails class="error-details">
        <summary>{{ 'auth.common.errorDetails' | translate }}</summary>
        <pre>{{ serverErrorDialogService.details }}</pre>
      </details>
    }
  </sm-confirmation-dialog>
}
